import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppData } from 'src/app/app.data';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { ApiResponseCode, FillFormTypes } from 'src/app/core/enums';
import { FormToSendModel } from 'src/app/core/models/form-to-send-model';
import { FormsService } from 'src/app/core/services/forms.service';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ScopeService } from 'src/app/core/services/scope.service';
import { SendFormAreYouSureDialogComponent } from 'src/app/dialogs/send-form-are-you-sure-dialog/send-form-are-you-sure-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastMsgService } from 'src/app/core/services/toast-msg.service';
import { SendFormToCustomerModel } from 'src/app/core/models/send-form-to-customer-model';
import { SendFormToTherapistModel } from 'src/app/core/models/send-form-to-therapist-model';
import { AuthenticateService } from 'src/app/core/services/authenticate.service';
import { CommonDialogComponent } from 'src/app/dialogs/common-dialog/common-dialog.component';


@Component({
  selector: 'app-select-form',
  templateUrl: './select-form.component.html',
  styleUrls: ['./select-form.component.scss']
})
export class SelectFormComponent implements OnInit {
  // router is located in scheduler.module select-form 
  form: UntypedFormGroup;
  error: string;
  settings: Settings;
  forms: FormToSendModel[] = [];
  businesses: any[] = [];
  branches:any[] = [];
  selectedForm: any;

  businessCaption = "Business"; // set deafult later we check with terminlogoy
  isBranchReadonly = false; 
  branchCaption = "Branch";





  constructor(
    public fb: UntypedFormBuilder,
    private appSettings: AppSettings,
    private location: Location,
    private router: Router,
    private translate: TranslateService,
    private formsService: FormsService,
    private scopeService: ScopeService,
    private toastService: ToastMsgService,
    private authService: AuthenticateService,
    private appData: AppData,
    private dialog: MatDialog) {

    this.settings = appSettings.settings;
  }

  ngOnInit(): void {
    
    const branchID = this.formsService.data.branchID;  // branchID is taken from appointment 
    const customerID = this.formsService.data.patient.ID;
    const customerName = this.formsService.data.patient.Name;
    const customerEmail = this.formsService.data.patient.Email;
    const therapistID = this.formsService.data.therapistID || 0;
    this.businessCaption = this.getBusinessCaption();
    this.branchCaption = this.translate.instant(`COMMON.BRANCH`);

    this.isBranchReadonly = false;
    
   

    const userScope = this.scopeService.userScope;
    const branches = userScope.userBranches;
   
    if (branchID > 0) {
      const branch = branches.filter(x => x.ID === branchID)[0];
      if (branch && branch.BusinessID > 0) {
        this.isBranchReadonly = true;
      }
    }
    else if(branches && branches.length === 1){
      // only one branch exists
      const branch = branches.filter(x => x.ID === branchID)[0];
      if (branch && branch.BusinessID > 0) {
        this.isBranchReadonly = true;
      }
    }
    

    this.form = this.fb.group({
      branchID: branchID,
      customerID: customerID,
      therapistID: therapistID,
      customerName: customerName,
      formID: '',
      search: ['']
    });


    this.loadForms();
    //this.loadBusinesses();
    this.loadBranches();
  }

  loadForms() {
    this.formsService.getForms().subscribe(result => {
      if (result.Code === ApiResponseCode.Success) {
        this.forms = result.Data.map(item => new FormToSendModel(item));
      } else {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
      }
    },
      error => {
        this.error = error;
      });
  }

  loadBusinesses() {
    const userScope = this.scopeService.userScope;
    this.businesses = userScope.userBusinesses; // [{ID, Name}]
  }

  loadBranches(){
    const userScope = this.scopeService.userScope;
    this.branches = userScope.userBranches;
  }


  onSelect(formItem: FormToSendModel) {
    
    
    

    this.f.formID.setValue(formItem.FormID);
    
    if(this.formsService.data.result === FormsService.SEND_TO_CUSTOMER){
      let formName = formItem.Name;
      let patientName = this.formsService.data.patient.Name;
      let msg = this.translate.instant('CONFIRM-SNED-CUSTOMER-FORM-MSG', { formName: formName, receipentName: patientName });
      // SEND FORM TO CUSTOMER
      const dialogRef = this.dialog.open(SendFormAreYouSureDialogComponent, {
        width: '400px',
        direction: (this.settings.rtl ? 'rtl' : null),
        data: { msg: msg }
      });

      dialogRef.afterClosed().subscribe(dialogResult => {
        if (dialogResult) {
          this.sendFormToCustomer();
        }
      });
    }    
    else if(this.formsService.data.result === FormsService.FILL_BY_THERAPIST){
      
      let msg = this.translate.instant(`MSG.FILL-FORM-BY-THERAPIST-MSG`);

      const dialogRef = this.dialog.open(CommonDialogComponent, {
        width: '400px',
        direction: (this.settings.rtl ? 'rtl' : null),
        data: { 
          message: msg,
          buttons: [
            { 
              name: 'ok',
              text: this.translate.instant('COMMON.OK'),
              color: 'accent',
              width: '40%'
            },
            { 
              name: 'cancel',
              text: this.translate.instant('COMMON.CANCEL'),              
              width: '40%'
            }
          ]

         }
      });

      dialogRef.afterClosed().subscribe(dialogResult => {
        if (dialogResult === 'ok') {
           // FILL FORM BY THERAPIST
          this.sendFormToTherapist();
        }
      });

      
    }
    
  }

  back() {
    this.location.back();
  }

  getBusinessCaption() {
    var resourceKey = this.scopeService.userScope.terminology.filter(x => x.TerminologyID === 1)[0].TargetResourceKey.toUpperCase();
    if(resourceKey === 'BUSINESS'){
      return this.translate.instant(`TERMINOLOGY.SELECT-BUSINESS`);
    }else if(resourceKey === 'CLINIC'){
      return this.translate.instant(`TERMINOLOGY.SELECT-CLINIC`);
    }
    return this.translate.instant(`TERMINOLOGY.${resourceKey}`);
  }

  sendFormToCustomer() {
    
    //var values = this.form.value;
    var values = this.form.getRawValue(); // get also disabled values

    var model = new SendFormToCustomerModel();
    model.CanSendEmail = true; // we send only to email
    model.CanSendSms = false;
    model.SelectedBranch = values.branchID;
    model.CustomerID = values.customerID;
    model.FormID = values.formID;
    model.SelectedForms = [values.formID];
    model.SendByEmail = true;


    this.formsService.sendFormToCustomer(model).subscribe(result => {
      if (result.Code === ApiResponseCode.Success) {
        // set reason
        var msg = this.translate.instant('MSG.FORM-SEND-SUCCESSFULLY');
        this.toastService.showSuccess(msg);

      } else if (result.Code === ApiResponseCode.Error) {
        this.error = result.Error;

      } else {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
      }
    },
      error => this.error = error
    );
  }

  sendFormToTherapist() {
    
    //var values = this.form.value;
    var values = this.form.getRawValue(); // get also disabled values

    var model = new SendFormToTherapistModel();
    model.CanSendEmail = true; // we do not send but just in case
    model.CanSendSms = true;
    model.NotifyByEmail = true;  
    model.NotifyBySMS = true;
    model.CustomerID = values.customerID;
    model.BranchID = values.branchID || 0;
    model.TherapistID = values.therapistID;   // the current userId should be therapist
    model.FillType = FillFormTypes.FillInPatientCard; // will genertae formData and return a url fo fill the form
    model.FormID = values.formID;


    this.formsService.sendFormToTherapist(model).subscribe(result => {
      if (result.Code === ApiResponseCode.Success) {

        if (window && result.Data.url) {
          // open url to fill form
          window.open(result.Data.url, "_blank");
        }
        else {
          // email was send to therapist
          var msg = this.translate.instant('MSG.FORM-SEND-SUCCESSFULLY');
          this.toastService.showSuccess(msg);
        }

      } else if (result.Code === ApiResponseCode.Error) {
        this.error = result.Error;

      } else {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
      }
    },
      error => this.error = error
    );
  }

  canSelectForm() {
    return this.f.branchID.value > 0;
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  // for debug only
  get diagnostic() { return JSON.stringify(this.form.value); }

}
